import { create } from '@thoughtspot/logger';
import { validateShowGlobalAlertToastEventPayloadObject } from './utils';
const logger = create('chart-to-ts > global-toast-events');
const getShowGlobalAlertToastEventProcessor = (props) => {
    const { setIsGlobalToastAlertVisible, setglobalToastAlertConfig } = props;
    return {
        validateEventPayload: (eventData) => {
            try {
                validateShowGlobalAlertToastEventPayloadObject(eventData.payload);
            }
            catch (err) {
                logger.warn(err);
                return {
                    isValid: false,
                    errors: [err.toString()],
                };
            }
            return {
                isValid: true,
            };
        },
        executeEvent: async (eventData) => {
            setIsGlobalToastAlertVisible(true);
            setglobalToastAlertConfig(eventData.payload);
            return Promise.resolve();
        },
    };
};
export { getShowGlobalAlertToastEventProcessor };
//# sourceMappingURL=index.js.map